import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { ToastProvider } from './components/Toast';
import Protected from './components/Protected';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Pacientes from './pages/Pacientes';
import PacienteDetail from './pages/PacienteDetail';
import Pipeline from './pages/Pipeline';
import Atendimentos from './pages/Atendimentos';
import Campanhas from './pages/Campanhas';
import AdminSettings from './pages/AdminSettings';
import AdminEmployees from './pages/AdminEmployees';
import AdminVissmedImport from './pages/AdminVissmedImport';

export default function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/pipeline" element={<Pipeline />} />
            <Route path="/atendimentos" element={<Atendimentos />} />
            <Route path="/pacientes" element={<Pacientes />} />
            <Route path="/pacientes/:id" element={<PacienteDetail />} />
            <Route path="/campanhas" element={<Campanhas />} />
            <Route path="/admin/settings" element={<Protected requireRole={['admin']}><AdminSettings /></Protected>} />
            <Route path="/admin/funcionarias" element={<Protected requireRole={['admin']}><AdminEmployees /></Protected>} />
            <Route path="/admin/vissmed-import" element={<Protected requireRole={['admin']}><AdminVissmedImport /></Protected>} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </ToastProvider>
    </AuthProvider>
  );
}
